<template>
  <div class="vp-donut-chart-container">
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      class="vp-svg"
    >
      <circle
        class="vp-base-circle"
        cx="10.5"
        cy="10.5"
        r="7.5"
      />
      <circle
        class="vp-actual-circle"
        :style="circleStyle"
        cx="10.5"
        cy="10.5"
        r="7.5"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  percent: number;
};

const props = defineProps<Props>();

const circleStyle = computed(() => {
  const circumference = Math.PI * 15;
  const offset = circumference - (props.percent / 100) * circumference;
  return {
    strokeDasharray: `${circumference} ${circumference}`,
    strokeDashoffset: offset,
  };
});
</script>
